import { useCallback } from 'react';

import lodashSet from 'lodash/set';

export const useValidation = ({ schema, values }) => {
  const generateErrors = useCallback((error) => {
    const { inner: rawInner } = error;
    const inner = rawInner ?? [];

    const result = {};
    const duplicates = new Set();

    for (const error of inner) {
      const { message, path } = error ?? {};

      if (!path || duplicates.has(path)) {
        continue;
      }

      lodashSet(result, path, message);
      duplicates.add(path);
    }

    return result;
  }, []);
  const validate = useCallback(async () => {
    if (!schema || !values) {
      return;
    }

    try {
      await schema.validate(values, { abortEarly: false });

      return {};
    } catch (error) {
      return generateErrors(error);
    }
  }, [schema, values, generateErrors]);
  const validateSync = useCallback(() => {
    if (!schema || !values) {
      return;
    }

    try {
      schema.validateSync(values, { abortEarly: false });

      return {};
    } catch (error) {
      return generateErrors(error);
    }
  }, [schema, values, generateErrors]);

  return { validate, validateSync };
};
